import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {DataManagementService} from '../../service/datamanagement/dataManagementService.js';
import {UnitService} from '../../service/unit/unitService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {ImportUtil} from '../../utils/importUtil.js';
import {ExportUtil} from '../../utils/exportUtil.js';
import {attachWorkspaceFilterState, readTypeAheadUnitState, restoreTypeAheadUnitState, resolveUnitByCode} from '../../utils/workspaceStateUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */
class DataLinkGrid extends BaseComponent {
	
	static get properties() {
		return {			
		};
	}
	
	constructor() {
		super();
		
		var dataLinkGrid = this;
		setTimeout(function(){
			dataLinkGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var dataLinkGrid = this;
		
		var currentRefType = '';
		var lookupRequestId = 0;
		var loadReferenceLookup = function (refType, lookupValue, selectedUnitId) {
			var requestId = ++lookupRequestId;
			var paging = {
				max: 100
			};
			if (lookupValue) {
				paging.filterField = 'description';
				paging.filterValue = lookupValue;
			}

			return UnitService.getUnitLookupService().getUnits(refType, paging).then(function (units) {
				if (requestId !== lookupRequestId) {
					return;
				}

				units.data = units.data || [];

				var unitField = ElementUtil.query(toolbarFilter, 'filterEquipmentId');
				var applyItems = function(items) {
					if (requestId !== lookupRequestId) {
						return;
					}
					unitField.items = items;
					if (selectedUnitId) {
						unitField.value = selectedUnitId;
					}
				};

				if (selectedUnitId) {
					var found = units.data.some(function(unit) {
						return unit.code === selectedUnitId;
					});
					if (!found) {
						return UnitService.getUnitLookupService().getUnits(refType, {
							max: 1,
							filterField: 'code',
							filterValue: selectedUnitId
						}).then(function(matched) {
							if (matched && matched.data && matched.data.length) {
								units.data = matched.data.concat(units.data);
							}
							applyItems(units.data);
						});
					}
				}
				applyItems(units.data);
			});
		};		
		
		var toolbarFilter = ElementUtil.create({
			tag: 'dl-toolbar',
		'collapse-label': 'Filter',
			slot: 'toolbar',
			theme: 'spacing',			
			children: [				
				{										
					tag: 'vaadin-combo-box',
					itemid: 'filterReferenceType',
					'class': 'spacer-toolbar-item',
					'keep-open': true,					
					style: 'width: 250px;',
					label: 'Reference Type',
					'item-value-path': 'code',
					'item-label-path': 'description',									
					postinit: function(combo) {						
						Service.getLookupService().getLookupValues('ReferenceType').then(function (data) {
							combo.items = data;
						});					
					},
					placeHolder: 'Select'					
				},
				{										
					tag: 'vaadin-combo-box',
					itemid: 'filterEquipmentType',
					'class': 'spacer-toolbar-item',
					'keep-open': true,					
					style: 'width: 250px;',
					label: 'Equipment Type',
					'item-value-path': 'code',
					'item-label-path': 'description',										
					postinit: function(combo) {						
						Service.getLookupService().getLookupValues('EquipmentType').then(function (data) {
							combo.items = data;
						});					
					},					
					placeHolder: 'Select',
					listeners: {
						change: function(e) {
							var typeCB = e.target;
							currentRefType = typeCB.value;
							
							//clear the reference no
							ElementUtil.query(toolbarFilter, 'filterEquipmentId').value = '';

							//load on type ahead
							loadReferenceLookup(currentRefType);
						}
					}
				},					
				{										
					tag: 'vaadin-combo-box',
					itemid: 'filterEquipmentId',
					'class': 'spacer-toolbar-item',
					'keep-open': true,					
					style: 'width: 250px;',
					label: 'Equipment No',
					'item-value-path': 'code',
					'item-label-path': 'description',									
					postinit: function(combo) {																	
					},
					placeHolder: 'Select',
					listeners: {
						input: {
							fn: function(e) {
								loadReferenceLookup(currentRefType, e.target.value);	
							},
							buffer: 500
						}
					}
				},
				{
					tag: 'vaadin-date-picker',
					'class': 'spacer-toolbar-item',
					itemid: 'filterStartDate',
					label: 'Filter Start Date',												
					name: 'filterStartDate',
					value: function() {
						return TimeUtil.formatDateForTimeField(TimeUtil.startPreviousMonth());	
					}()
				},
				{
					tag: 'vaadin-date-picker',
					'class': 'spacer-toolbar-item',
					itemid: 'filterEndDate',
					label: 'Filter End Date',												
					name: 'filterEndDate',
					value: function() {
						return TimeUtil.formatDateForTimeField(TimeUtil.endPreviousMonth());	
					}()
				}				
			]
		});		
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{
					tag: 'span',
					innerHTML: '|'
				},
				{
					tag: 'dl-action-button',
					itemid: 'add',
					theme: 'primary',
					'class': 'spacer-toolbar-item',					
					permissions: ['DATA_LINKS:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:plus', ' Add')						
					],
					listeners: {
						click: function() {
							actionAddEdit();
						}
					}					
				},
				{
					tag: 'dl-action-button',
					itemid: 'edit',
					'class': 'spacer-toolbar-item',
					disabled: true,	
					permissions: ['DATA_LINKS:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:edit', ' Edit')						
					],
					listeners: {
						click: function() {
							actionAddEdit(grid.selectedItems[0]);
						}
					}					
				},
				{
					tag: 'div',
					style: 'float: right;',
					children:[
						{
							tag: 'dl-action-button',
							itemid: 'upload',
							'class': 'spacer-toolbar-item',					
							permissions: ['DATA_LINKS:WRITE'],						
							children:[
								ElementUtil.makeIcon('vaadin:upload', ' Import')						
							],
							listeners: {
								click: function() {
									actionUpload();
								}
							}							
						},
						{
							tag: 'dl-action-button',
							itemid: 'delete',
							'class': 'spacer-toolbar-item',	
							theme: 'error primary',
							permissions: ['DATA_LINKS:DELETE'],							
							children:[
								ElementUtil.makeIcon('vaadin:trash', ' Delete')						
							],
							listeners: {
								click: function() {
									actionDelete(grid.selectedItems);
								}
							}							
						}
					]
				}											
			]
		});		
		
		var toolbarContainer = ElementUtil.create({
			tag: 'div',
			slot: 'toolbar',
			children: [
				toolbarFilter,
				ElementUtil.create({
					tag: 'hr'
				}),
				toolbar
			]
		});			
	
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'wrap-cell-content row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true,
				listeners: {
					'direction-changed' : function(event) {
						if (event.detail && event.detail.value) {
							grid.currentSortField = event.target.path;
							grid.currentSortDirection = event.detail.value.toUpperCase();
							pagingToolbar.loadCurrentPage();
						}
					}
				}
			},			
			children: [
				{
					tag: 'vaadin-grid-selection-column',
					itemid: 'selectionColumn',
					'auto-select': true,
					'auto-width': true,
					listeners: {
						'select-all-changed': function() {
							gridSelectionChange();
						}
					}					
				},				
				{						
					path: 'equipmentType',
					header: 'Equipment Type',
					width: '7em'
				},	
				{						
					path: 'equipmentRefNo',
					header: 'Equipment No',
					width: '7em'
				},
				{						
					path: 'referenceType',
					header: 'Reference Type',
					width: '7em'
				},
				{						
					path: 'referenceNo',
					header: 'Reference no',
					width: '7em'
				},
				{						
					path: 'referenceDesc',
					header: 'Reference Desc',
					width: '7em'
				},
				{						
					path: 'referenceAltNo',
					header: 'Reference Alt No',
					width: '7em'
				},
				{						
					path: 'beginDts',
					header: 'Begin Date',
					width: '7em',					
					renderer: function(root, column, rowData) {
						if (rowData.item.beginDts) {
							var date = TimeUtil.parseDate(rowData.item.beginDts);						
							root.innerHTML = TimeUtil.formatDateStandard(date);						
						} else {
							root.innerHTML = 'N/A';						
						}
					}
				},
				{						
					path: 'endDts',
					header: 'End Date',
					width: '7em',					
					renderer: function(root, column, rowData) {
						if (rowData.item.endDts) {
							var date = TimeUtil.parseDate(rowData.item.endDts);						
							root.innerHTML = TimeUtil.formatDateStandard(date);						
						} else {
							root.innerHTML = 'N/A';
						}
					}
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;					
				},
				'click': function(e) {
					gridSelectionChange();
				}
			}
		});	
			
		var gridSelectionChange = function() {
			setTimeout(function(){
				if (grid.selectedItems.length > 0) {
					if (grid.selectedItems.length === 1) {
						ElementUtil.query(toolbar, 'edit').disabled = false;
						ElementUtil.query(toolbar, 'delete').disabled = false;
					} else {
						ElementUtil.query(toolbar, 'edit').disabled = true;
						ElementUtil.query(toolbar, 'delete').disabled = false;
					}
				} else {						
					ElementUtil.query(toolbar, 'edit').disabled = true;	
					ElementUtil.query(toolbar, 'delete').disabled = true;
				}	
			});
		};	
			
		var pagingToolbar = ElementUtil.create({
			tag: 'dl-paging-toolbar',
			pageSize: 100,
			postinit: function(element) {
				element.grid = grid;
				element.loader = function(backingGrid, pageNumber, pagingToolbar) {
					var pageRange = pagingToolbar.pullRange();
					var loadMask = grid.showLoading();
										
					var loadData = function() {
												
						var startFilterDts = TimeUtil.startOfDayCompanyTime(ElementUtil.query(toolbarFilter, 'filterStartDate').value);										
						var endFilterDts =  TimeUtil.endOfDayCompanyTime(ElementUtil.query(toolbarFilter, 'filterEndDate').value);														
												
						grid.currentFilter = {
							offset: pageRange.offset,
							max: pageRange.max,
							sortField: backingGrid.currentSortField ? backingGrid.currentSortField : 'beginDts',
							sortOrder: backingGrid.currentSortDirection	? backingGrid.currentSortDirection : 'ASC',
							start:  startFilterDts,														
							end: endFilterDts,
							dateField: 'beginDts',
							filterField: 'referenceType',
							filterValue: ElementUtil.query(toolbarFilter, 'filterReferenceType').value,
							equipmentType: ElementUtil.query(toolbarFilter, 'filterEquipmentType').value,
							equipmentId: ElementUtil.query(toolbarFilter, 'filterEquipmentId').value
						};
																		
						var successHandler = function(records) {
							loadMask.remove();
							grid.activeItem = null;						
							grid.items = records.data;

							pagingToolbar.totalRecords = records.totalNumber;
							pagingToolbar.updatePager();						
						};
						
						DataManagementService.getDataLinkService().getDataLinks(grid.currentFilter).then(function(records){
							successHandler(records);
						});						
					};	
					
					loadData();														
				};
			},
			listeners: {
				ready: function() {					
					pagingToolbar.loadCurrentPage();					
				}
			}
			
		});			
		
		var footer = ExportUtil.createExportFooter({
			pagingToolbar: pagingToolbar,
			grid: grid,
			itemid: 'primary',
			onDetail: function() {
				var exportFilter = Object.assign({}, grid.currentFilter || {});
				delete exportFilter.offset;
				delete exportFilter.max;
				DataManagementService.getDataLinkService().exportDataLinks(exportFilter);
			}
		});
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbarContainer,
				grid,
				footer.footerContainer
			]
		});		
		dataLinkGrid.append(flexLayout);		
			
		var actionRefresh = function() {
			pagingToolbar.loadPage(1);	
		};

		attachWorkspaceFilterState(dataLinkGrid, toolbarFilter,
			['filterReferenceType','filterEquipmentType','filterEquipmentId','filterStartDate','filterEndDate'],
			actionRefresh,
			{
				save: function(state) {
					var unitState = readTypeAheadUnitState(ElementUtil.query(toolbarFilter, 'filterEquipmentId'));
					state.filterEquipmentId = unitState.value;
					state.filterEquipmentDescription = unitState.description;
				},
				restore: function(data) {
					if (data.filterReferenceType !== undefined && data.filterReferenceType !== null) {
						ElementUtil.query(toolbarFilter, 'filterReferenceType').value = data.filterReferenceType;
					}
					var equipmentType = data.filterEquipmentType;
					if (equipmentType !== undefined && equipmentType !== null) {
						ElementUtil.query(toolbarFilter, 'filterEquipmentType').value = equipmentType;
						currentRefType = equipmentType;
					} else {
						equipmentType = ElementUtil.query(toolbarFilter, 'filterEquipmentType').value;
						currentRefType = equipmentType || currentRefType;
					}
					if (data.filterStartDate !== undefined && data.filterStartDate !== null) {
						ElementUtil.query(toolbarFilter, 'filterStartDate').value = data.filterStartDate;
					}
					if (data.filterEndDate !== undefined && data.filterEndDate !== null) {
						ElementUtil.query(toolbarFilter, 'filterEndDate').value = data.filterEndDate;
					}
					restoreTypeAheadUnitState({
						combo: ElementUtil.query(toolbarFilter, 'filterEquipmentId'),
						refType: currentRefType || equipmentType,
						unitId: data.filterEquipmentId,
						description: data.filterEquipmentDescription,
						loadLookup: loadReferenceLookup,
						resolveByCode: function(type, unitId) {
							return resolveUnitByCode(function(referenceType, paging) {
								return UnitService.getUnitLookupService().getUnits(referenceType, paging);
							}, type, unitId);
						}
					}).then(function() {
						actionRefresh();
					});
				}
			});
				
		var actionAddEdit = function(record) {
			var addEditWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: record ? 'Edit Data Link' : 'Add Data Link',
				icon: 'vaadin:edit',				
				width: .75,
				height: .80,
				listeners: {
					ready: function() {						
						addEditWin.show();
						
						
						var loadReferenceNo = function (refType, lookupValue, cbToPopulate) {
							var paging = {
								max: 100
							};
							if (lookupValue) {
								paging.filterField = 'description';
								paging.filterValue = lookupValue;
							}
							UnitService.getUnitLookupService().getUnits(refType, paging).then(function (units) {
								cbToPopulate.items = units.data;
							});

						};
						
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [
										{
											tag: 'vaadin-combo-box',
											itemid: 'referenceTypeCB',
											label: 'Reference Type',
											name: 'referenceType',
											'item-value-path': 'code',
											'item-label-path': 'description',
											required: true,
											postinit: function (combo) {
												Service.getLookupService().getLookupValues('ReferenceType').then(function (data) {
													combo.items = data;
												});
											},
											listeners: {
												change: function(e) {
													var typeCB = e.target;
													var newValue = typeCB.value;
																										
													ElementUtil.query(formPanel, 'referenceNoCB').value = '';
													var initRefNo = null;
													if (e.detail) {
														initRefNo = e.detail;
													}
													loadReferenceNo(newValue, initRefNo, ElementUtil.query(formPanel, 'referenceNoCB'));																																								
												}
											}
										},
										{
											tag: 'vaadin-combo-box',
											itemid: 'referenceNoCB',
											label: 'Reference No',
											name: 'referenceNo',
											'item-value-path': 'code',
											'item-label-path': 'description',
											required: true,
											'allow-custom-value': true,
											postinit: function (combo) {												
											},
											listeners: {
												input: {
													fn: function (e) {
														var refNoCB = ElementUtil.query(formPanel, 'referenceNoCB');
														var refType = ElementUtil.query(formPanel, 'referenceTypeCB').value;														
														loadReferenceNo(refType, ElementUtil.resolveComboInputValue(e, refNoCB), refNoCB);															
													},
													buffer: 500
												}
											}
										},										
										{
											tag: 'vaadin-text-field',										
											name: 'referenceDesc',
											label: 'Reference Description',										
											maxLength: 255											
										},
										{
											tag: 'vaadin-text-field',										
											name: 'referenceAltNo',
											label: 'Reference Alternate No',											
											maxLength: 255											
										},
										{
											tag: 'vaadin-date-time-picker',
											label: 'Begin Date',
											name: 'beginDts',
											step: 30,
											required: true
										},	
										{
											tag: 'vaadin-date-time-picker',
											label: 'End Date',											
											name: 'endDts',	
											step: 30,
											required: true
										},
										{
											tag: 'vaadin-combo-box',
											itemid: 'timezoneCB',
											label: 'TimeZone',
											name: 'timezone',
											'item-value-path': 'code',
											'item-label-path': 'description',
											value: TimeUtil.getCompanyTimeZoneNameOnly(),
											postinit: function (combo) {
												Service.getLookupService().getLookupValues('TimeZone').then(function (data) {
													combo.items = data;
												});
											}											
										},										
										{
											tag: 'vaadin-combo-box',
											itemid: 'equipmentTypeCB',
											label: 'Equipment Type',
											name: 'equipmentType',
											'item-value-path': 'code',
											'item-label-path': 'description',
											required: true,
											postinit: function (combo) {
												Service.getLookupService().getLookupValues('EquipmentType').then(function (data) {
													combo.items = data;
												});
											},
											listeners: {
												change: function(e) {
													var typeCB = e.target;
													var newValue = typeCB.value;
													
													ElementUtil.query(formPanel, 'equipmentNoCB').value = '';
													var initRefNo = null;
													if (e.detail) {
														initRefNo = e.detail;
													}
													loadReferenceNo(newValue, initRefNo, ElementUtil.query(formPanel, 'equipmentNoCB'));
												}
											}
										},
										{
											tag: 'vaadin-combo-box',
											itemid: 'equipmentNoCB',
											label: 'Equipment No',
											name: 'equipmentId',
											'item-value-path': 'code',
											'item-label-path': 'description',
											required: true,											
											postinit: function (combo) {												
											},
											listeners: {
												input: {
													fn: function (e) {
														var refNoCB = ElementUtil.query(formPanel, 'equipmentNoCB');
														var refType = ElementUtil.query(formPanel, 'equipmentTypeCB').value;														
														loadReferenceNo(refType, ElementUtil.resolveComboInputValue(e, refNoCB), refNoCB);															
													},
													buffer: 500
												}
											}
										},										
										{
											tag: 'vaadin-number-field',										
											name: 'beginOdometer',
											label: 'Begin Odometer',
											min: 0,
											max: 999999999
										},
										{
											tag: 'vaadin-number-field',										
											name: 'endOdometer',
											label: 'End Odometer',
											min: 0,
											max: 999999999
										},
										{
											tag: 'vaadin-number-field',										
											name: 'totalMiles',
											label: 'Total Miles',
											min: 0,
											max: 9999999										
										},
										{
											tag: 'vaadin-number-field',										
											name: 'totalFuelGallons',
											label: 'Total Fuel Gallons',
											min: 0,
											max: 9999999
										},
										{
											tag: 'vaadin-number-field',										
											name: 'axelCount',
											label: 'Axel Count',
											min: 0,
											max: 9999
										},
										{
											tag: 'vaadin-number-field',										
											name: 'cargoWeight',
											label: 'Cargo Weight',
											min: 0,
											max: 99999999
										},
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Save')
													],
													listeners: {
														click: function() {															
																		
															var timezone = ElementUtil.query(formPanel, 'timezoneCB').value;			
																													
															formPanel.submitForm({
																timezone: timezone,
																preSubmit: function(data) {
																	var selectedRef = ElementUtil.query(formPanel, 'referenceNoCB').selectedItem;	
																	if (selectedRef) {
																		data.referenceNo = selectedRef.description;
																		data.referenceId = selectedRef.code;
																	}
																	return data;
																},
																actualCall: function(data) {			
																	if (record) {
																		data.dataLinkId = record.dataLinkId;
																	}
																	return DataManagementService.getDataLinkService().saveDataLink(data, (record ? true : false));
																},
																success: function(data, responseData) {
																	window.DL.MessageUtil.showToast('Success', 'Saved Data Link', {
																		theme: 'success',
																		position: 'top-stretch'
																	});
																	actionRefresh();
																	addEditWin.close();
																}
															});															
															
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															//cancel
															addEditWin.close();
														}
													}
												}
											]
										}
									]
								}
							]
						});			
						
						addEditWin.addToContentElement(formPanel);
						
						if (record) {	
							formPanel.load(record);
							
							var event = new Event('change');
							event.detail = record.referenceNo;
							ElementUtil.query(formPanel, 'referenceTypeCB').dispatchEvent(event);
							
							event = new Event('change');
							event.detail = record.equipmentRefNo;
							ElementUtil.query(formPanel, 'equipmentTypeCB').dispatchEvent(event);
							
							setTimeout(function(){
								var refNoCB = ElementUtil.query(formPanel, 'referenceNoCB');
								refNoCB.value = record.referenceNo;
								
								var equipmentCB = ElementUtil.query(formPanel, 'equipmentNoCB');
								equipmentCB.value = record.equipmentId;																						
							}, 500);
							
						}
					}
				}
			});			
		};
		
		var actionDelete = function(records) {
			
			var multipleIds = {
				ids: []
			};
			records.forEach(function(record){
				multipleIds.ids.push(
					record.dataLinkId
				);
			});
	
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Delete',
				message: 'Are you sure you want to delete selected records?',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Removing...');

							DataManagementService.getDataLinkService().deleteDataLink(multipleIds)
							.then(function(){
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Removed records', {									
									theme: 'success'
								});
								actionRefresh();
							});						
						}
					},
					{
						text: 'No'
					}
				]
			});
			
		};	
		
		var actionUpload = function() {
			ImportUtil.showUpload({
				dataTypes: 'DATA_LINK',
				visibleOptions: [
					'inputTimeZone',
					'unitMatchId',
					'autoUnitId',
					'datafilterId',
					'autoGroupId',
					'dataTransformRuleSetId'
				],
				uploadUrl: '/api/resource/data-links/import'
			});
		};		
	
	}
	
}
customElements.define('dl-datalink-grid', DataLinkGrid);